import React from 'react';
import ReactDOM from 'react-dom';
import 'moment/locale/es';
import Moment from 'react-moment';
import moment from 'moment-timezone';

import { Provider } from 'react-redux';
import { store, history } from './redux/store';

import './index.scss';
import App from './App';

import * as serviceWorker from './serviceWorker';
import { ConnectedRouter } from 'connected-react-router';

Moment.globalLocale = 'es';
Moment.globalFormat = 'D MMM YYYY';
Moment.globalTimezone = 'America/Lima';
moment.locale('es');
moment.tz.setDefault("America/Lima");

// window.addEventListener("beforeunload", (e) =>
// {
//   e.preventDefault();
//   return e.returnValue = "Leaving this page will reset the wizard";
// });
//
// window.addEventListener('unload', () => {
//   authProvider.logout();
// });

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
